import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { ICampaignListContainer } from "../../features/Campaigns/interface/shared";
import { IAppleAdsCampaign } from "../../features/Campaigns/interface/appleAds";
import dayjs from "dayjs";

interface UseAppleAdsCampaignsParams {
  startDate?: Date;
  endDate?: Date;
  status?: string;
  search?: string;
  page?: number;
  per_page?: number;
  sort_by?: string;
  sort_order?: "asc" | "desc";
  trackingId?: string;
  socialAccountId?: number;
}

export const useAppleAdsCampaigns = (params?: UseAppleAdsCampaignsParams) => {
  return useQuery<ICampaignListContainer<IAppleAdsCampaign>, Error>({
    queryKey: [
      "apple-search-ads-campaigns",
      params?.startDate?.toISOString(),
      params?.endDate?.toISOString(),
      params?.status,
      params?.search,
      params?.page,
      params?.per_page,
      params?.sort_by,
      params?.sort_order,
      params?.trackingId,
      params?.socialAccountId,
    ],
    queryFn: async () => {
      const queryParams = {
        page: params?.page || 1,
        per_page: params?.per_page || 10,
        ...(params?.startDate && { start_date: dayjs(params.startDate).format("YYYY-MM-DD") }),
        ...(params?.endDate && { end_date: dayjs(params.endDate).format("YYYY-MM-DD") }),
        ...(params?.status && { status: params.status }),
        ...(params?.search && { search: params.search }),
        ...(params?.sort_by && { sort_by: params.sort_by }),
        ...(params?.sort_order && { sort_order: params.sort_order }),
        ...(params?.trackingId && { tracking_id: params.trackingId }),
        ...(params?.socialAccountId && { social_account_id: params.socialAccountId }),
      };

      return httpService.get<ICampaignListContainer<IAppleAdsCampaign>>(
        API_CONFIG.path.appleAdsCampaigns,
        queryParams
      );
    },
    placeholderData: (previousData) => previousData,
  });
};
